export enum ContractState {
  draft = 'draft',
  contract = 'contract',
  canceled = 'canceled',
  terminatedBeforeDelivery = 'terminated_before_delivery',
}

export const getContractStateFromValue = (value): ContractState => {
  const index = Object.values(ContractState).indexOf(value);
  if (index < 0) {
    throw new Error('Unknown contract state ' + value);
  }

  return Object.keys(ContractState)[index] as ContractState;
};
